import React from 'react';
import Icon from '../../../components/AppIcon';
import EditorModalPortal from './EditorModalPortal';

export default function ExternalSiteModal({ url, title, onClose }) {
  if (!url) return null;

  return (
    <EditorModalPortal
      open
      className="fixed inset-0 flex flex-col bg-black/60 p-3 sm:p-6"
    >
      <div className="mx-auto w-full max-w-6xl flex-1 min-h-0 flex flex-col rounded-xl bg-card border border-border shadow-elevation-3 overflow-hidden">
        <div className="flex items-center justify-between gap-3 border-b border-border px-4 py-3 shrink-0">
          <div className="min-w-0">
            <p className="text-sm font-semibold text-foreground truncate">
              {title || 'Site externe'}
            </p>
            <p className="text-[11px] text-muted-foreground truncate">{url}</p>
          </div>
          <div className="flex items-center gap-2 shrink-0">
            <a
              href={url}
              target="_blank"
              rel="noopener noreferrer"
              className="text-xs text-primary hover:underline px-2"
            >
              Ouvrir dans un onglet
            </a>
            <button
              type="button"
              onClick={onClose}
              className="p-2 rounded-lg hover:bg-muted"
              aria-label="Fermer"
            >
              <Icon name="X" size={18} />
            </button>
          </div>
        </div>
        <iframe
          title={title || 'Site externe'}
          src={url}
          className="flex-1 w-full min-h-0 bg-white"
          sandbox="allow-scripts allow-same-origin allow-forms allow-popups allow-popups-to-escape-sandbox"
        />
      </div>
    </EditorModalPortal>
  );
}
